var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.value),function(link,index){return _c('a',{key:index,class:{'focus': link.focus},attrs:{"href":link.target}},[_vm._v(_vm._s(link.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }